import {
  EntityVersioning,
  EntityVersioningParams,
} from '../../EntityVersioning';

export class ArmyListVersioning extends EntityVersioning<string> {
  armyId: number;

  constructor(params: ArmyListVersioningParams) {
    super(params);
    this.armyId = params.armyId;
  }
}

export type ArmyListVersioningParams = EntityVersioningParams<string> & {
  armyId: number;
};
